//const Base="http://192.168.1.27:808/";
//const Base="http://localhost:22024/";
//const Base="http://192.168.50.152:5010/";
//const Base="http://192.168.1.27:7574/";


const Base="https://hr.packesfahan.com:808/";
//const Base="https://localhost:44352/";
export const BaseApi = Base+'api/';
export const BaseFile = Base+'';